import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import React from 'react';

function DesktopMenuButton({
  text,
  icon,
  onClick = () => {},
  active = false,
}: {
  text: string;
  icon: JSX.Element;
  onClick?: () => void;
  active?: boolean;
}) {
  return (
    <Card
      elevation={active ? 10 : 1}
      sx={{
        mb: 3,
        borderRadius: 2,
        border: (t: Theme) => `1px solid ${t.palette.divider}`,
        overflow: 'hidden',
      }}
    >
      <CardActionArea onClick={onClick} sx={{ borderRadius: 'inherit' }}>
        <CardContent sx={{ textAlign: 'center', px: 0.5, py: 1.5 }}>
          <Typography color="text.secondary">{icon}</Typography>
          <Typography variant="caption" color="text.secondary">
            {text}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default DesktopMenuButton;
